import styles from '../styles/Services.module.css';

const ICONS = {
  wp: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="12" cy="12" r="9" />
      <path d="M4.2 10.5h3.4l2.9 8.3M9.6 7.2 11 11l-2.6 7.4M14.4 7.2h4.7M13 11l3.4 8.3c1.4-.9 2.5-2.2 3.2-3.7" />
    </svg>
  ),
  stack: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="m12 3 9 4.7-9 4.7-9-4.7 9-4.7Z" />
      <path d="m3 12.3 9 4.7 9-4.7M3 16.6 12 21l9-4.4" />
    </svg>
  ),
  server: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="3.5" y="4" width="17" height="6.5" rx="1" />
      <rect x="3.5" y="13.5" width="17" height="6.5" rx="1" />
      <circle cx="7" cy="7.25" r="0.75" fill="currentColor" stroke="none" />
      <circle cx="7" cy="16.75" r="0.75" fill="currentColor" stroke="none" />
    </svg>
  ),
  seo: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="10.5" cy="10.5" r="6.5" />
      <path d="m20 20-4.6-4.6" />
    </svg>
  ),
};

const SERVICES = [
  {
    title: 'WordPress Development',
    accent: 'cy',
    icon: 'wp',
    desc: 'Custom themes and plugins built from scratch, WooCommerce stores, Tutor LMS platforms, and ACF-driven content architecture — 100+ sites shipped.',
  },
  {
    title: 'MERN & SaaS Development',
    accent: 'pu',
    icon: 'stack',
    desc: 'Full-stack product builds on MongoDB, Express, React and Node — multi-tenant SaaS, billing integrations, JWT auth, and real-time features with Socket.io.',
  },
  {
    title: 'Server & DevOps',
    accent: 'cy',
    icon: 'server',
    desc: 'Shared hosting and VPS server management, DNS management, and SPF/DKIM/DMARC email deliverability setup.',
  },
  {
    title: 'SEO & Performance',
    accent: 'pu',
    icon: 'seo',
    desc: 'Technical SEO audits, Core Web Vitals tuning, and Schema.org markup — driving 90+ Google PageSpeed scores across 20+ production websites.',
  },
];

export default function Services() {
  return (
    <section id="services" className="section">
      <div className="container">
        <div className="section-head" data-anim>
          <span className="section-index">03</span>
          <span className="section-rule" />
          <h2 className="section-title">What I Offer</h2>
        </div>

        <div className={styles.grid}>
          {SERVICES.map((service) => (
            <div key={service.title} className={`${styles.card} ${styles[service.accent]}`} data-anim data-tilt>
              <span className={`${styles.iconWrap} ${styles[service.accent]}`}>{ICONS[service.icon]}</span>
              <h3 className={styles.title}>{service.title}</h3>
              <p className={styles.desc}>{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
